/**
 * Mock transaction data for the Wallet page.
 *
 * Simulates past orders and earnings history with chips and dollar amounts.
 */

/**
 * Past orders -- Spades spent on streams and messages.
 */
export const PAST_ORDERS = [
  { id: 1, account: 'DougDoug', content: 'Stream', date: '7/7/2026', chips: 2500, dollars: 5.00, status: 'Completed' },
  { id: 2, account: 'Jenny', content: 'Stream', date: '7/7/2026', chips: 10081, dollars: 20.16, status: 'Completed' },
  { id: 3, account: 'randouser', content: 'Stream', date: '7/7/2026', chips: 3000, dollars: 6.00, status: 'Completed' },
  { id: 4, account: 'MisterPeanutButter', content: 'Stream', date: '7/7/2026', chips: 5000, dollars: 10.00, status: 'Completed' },
  { id: 5, account: 'Markimoo', content: 'Stream', date: '7/7/2026', chips: 1000, dollars: 2.00, status: 'Completed' },
  { id: 6, account: 'OscarTheCouch', content: 'Message', date: '7/4/2026', chips: 5000, dollars: 10.00, status: 'Completed' },
  { id: 7, account: 'kermit', content: 'Stream', date: '7/2/2026', chips: 65000, dollars: 130.00, status: 'Completed' },
  { id: 8, account: 'Karen', content: 'Stream', date: '7/2/2026', chips: 2000, dollars: 4.00, status: 'Completed' },
  { id: 9, account: 'bigbord', content: 'Stream', date: '7/2/2026', chips: 4500, dollars: 9.00, status: 'Completed' },
  { id: 10, account: 'bERT', content: 'Stream', date: '7/2/2026', chips: 8000, dollars: 16.00, status: 'Completed' },
  { id: 11, account: 'badperson', content: 'Message', date: '6/18/2026', chips: 5000, dollars: 10.00, status: 'Completed' },
];

/**
 * Earnings -- Spades received from viewers as a streamer.
 */
export const EARNINGS = [
  { id: 1, account: 'DougDoug', content: 'Stream', date: '7/7/2026', chips: 2500, dollars: 5.00, status: 'Paid' },
  { id: 2, account: 'Jenny', content: 'Stream', date: '7/7/2026', chips: 10081, dollars: 20.16, status: 'Paid' },
  { id: 3, account: 'randouser', content: 'Stream', date: '7/7/2026', chips: 3000, dollars: 6.00, status: 'Paid' },
  { id: 4, account: 'MisterPeanutButter', content: 'Stream', date: '7/7/2026', chips: 5000, dollars: 10.00, status: 'Pending' },
  { id: 5, account: 'Markimoo', content: 'Stream', date: '7/7/2026', chips: 1000, dollars: 2.00, status: 'Paid' },
  { id: 6, account: 'OscarTheCouch', content: 'Message', date: '7/4/2026', chips: 5000, dollars: 10.00, status: 'Paid' },
  { id: 7, account: 'kermit', content: 'Stream', date: '7/2/2026', chips: 65000, dollars: 130.00, status: 'Paid' },
  { id: 8, account: 'Karen', content: 'Stream', date: '7/2/2026', chips: 2000, dollars: 4.00, status: 'Paid' },
  { id: 9, account: 'bigbord', content: 'Stream', date: '7/2/2026', chips: 4500, dollars: 9.00, status: 'Pending' },
  { id: 10, account: 'bERT', content: 'Stream', date: '7/2/2026', chips: 8000, dollars: 16.00, status: 'Paid' },
  { id: 11, account: 'badperson', content: 'Message', date: '6/18/2026', chips: 5000, dollars: 10.00, status: 'Paid' },
];

/**
 * Status color mapping for consistent styling.
 */
export const TRANSACTION_STATUS_COLORS = {
  'Completed': '#22c55e',
  'In Progress': '#4a8a9e',
  'Paid': '#22c55e',
  'Pending': '#4a8a9e',
  'Received': '#22c55e',
  'Refunded': '#22c55e',
};
